import { BaseApi } from './base.api.js';

export class BusinessCalendarApi extends BaseApi {
    constructor(client) {
        super(client, '/business-calendar');
    }

    async getHours() {
        const response = await this.client.get(`${this.basePath}/hours`);
        return response.data;
    }

    async upsertHours(body) {
        const response = await this.client.put(`${this.basePath}/hours`, body || {});
        return response.data;
    }

    async listHolidays() {
        const response = await this.client.get(`${this.basePath}/holidays`);
        return response.data;
    }

    async createHoliday(body) {
        const response = await this.client.post(`${this.basePath}/holidays`, body || {});
        return response.data;
    }

    async deleteHoliday(id) {
        const response = await this.client.delete(`${this.basePath}/holidays/${id}`);
        return response.data;
    }

    async previewDeadline(body) {
        const response = await this.client.post(`${this.basePath}/preview-deadline`, body || {});
        return response.data;
    }
}
